

$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn span").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
    
});


$(document).ready(function() {
var owl = $('.feturecaro.owl-carousel');
  owl.owlCarousel({
    dots: true,
     margin:15,
    navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      500: {	
        items: 1
      },
      576: {	
        items:2
      },
      768: {
        items: 2
      },         
      1300: {
        items:3
      },
      1400: {
        items: 3
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.indutry-caro.owl-carousel');
  owl.owlCarousel({
    dots: false,
    margin:0,
    navText : ["<i class='fa-solid fa-arrow-left'></i>","<i class='fa-solid fa-arrow-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.testecaro.owl-carousel');
  owl.owlCarousel({
    dots: false,
    navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
        items: 1
      },
      481: {	
        items: 1
      },
      576: {	
        items: 2
      },
      1200: {
        items: 2
      }
    }
  });
});


$(document).ready(function() {
  var owl = $('.trangCaro.owl-carousel');

  owl.owlCarousel({
    dots: false,
    margin: 20,
    navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true, // Ensure it doesn't loop
    responsive: {
      0: { items: 1 },
      481: { items: 1 },
      576: { items: 2 },
      900: { items: 2, margin: 20 },
      1200: { items: 3, margin: 25 }
    },
    onInitialized: function(event) {
      checkNavButtons(event);
    },
    onChanged: function(event) {
      checkNavButtons(event);
    }
  });

  function checkNavButtons(event) {
    var itemCount = event.item.count; // Total number of items
    var currentIndex = event.item.index; // Current index
    var visibleItems = event.page.size; // Number of visible items at once
    var lastIndex = itemCount - visibleItems; // Last possible index before the end

    if (currentIndex === 0) {
      $('.owl-prev').prop('disabled', true); // Disable prev on first item
    } else {
      $('.owl-prev').prop('disabled', false);
    }

    if (currentIndex >= lastIndex) {
      $('.owl-next').prop('disabled', true); // Disable next on last item
    } else {
      $('.owl-next').prop('disabled', false);
    }
  }
});






